import { Component, OnInit, ElementRef , ViewChild} from '@angular/core';
import { SelfService } from '../../bpg-self-services/self-services.service.ts';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LandingPaginationDTO } from "../../bpg-common/services/data.services";
import { ConstantValues } from '../../bpg-common/models/bpg-constants';

import { Router } from '@angular/router';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import {  Location } from '@angular/common';


@Component({
  selector: 'app-additionalresource-folder',
  templateUrl: './additionalresource-folder.component.html',
  styleUrls: ['./additionalresource-folder.component.css']
})
export class AdditionalresourceFolderComponent implements OnInit {
  @ViewChild('myInput', { static: false })
  myInputVariable: ElementRef;
  LandingPaginationDTO: LandingPaginationDTO = new LandingPaginationDTO();
  landingDto: any;
  noDataFound: boolean;
  alertSuccess: boolean;
  alertFailure: boolean;
  deleteSuccess: boolean;
  errorMsg: any;
  msg1: string;
  method: string;
  param: any;
  loginData: any = JSON.parse(localStorage.getItem('loginData'));
  loginUserId: string;
  chapterId: number;
  createdBy: any = this.loginData.userId;
  createdDateTime: any;
  modifiedBy: any = this.loginData.userId;
  modifiedDateTime: any;
  userId: any = this.loginData.userId;
  numberOfElements: number;
  currentPage = 0;
  currentNumberOfElements = 10;
  totalPages = 0;
  tableShow: any;
  limit = 10;
  currentShowingElements = 10;
  searchKey: any;
  searchTerm: any;
  landingData: any;
  tableresp: boolean;
  loginDetails: any = JSON.parse(localStorage.getItem("loginData"));
  loginDataDetails: any = JSON.parse(localStorage.getItem('loginData'));
  page = 0;
  documentsFolderList: any = null;
  timeOutError: boolean;
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
  errorMsgUploadSave = false;
  userAndRoleIdDTO: any;
  filterType: any;
  folderName: any;
  folderOrder : any;
  folderId: any = null;
  editAndSave = false;
  alertUpdateSuccess = false;
  errorMessage:any;
  firstEdit = false;


constructor(private readonly userService: SelfService,
    private readonly spinner: Ng4LoadingSpinnerService,
    
    private readonly router: Router,
    private readonly  environment: EnvironmentConfiguration,
    private readonly location: Location) { }

  ngOnInit() {
    if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
              if (localStorage.getItem('loginData')=== null || localStorage.getItem('loginData')=== undefined) {

	   this.router.navigate(['/log-out']);
      }
    }

    if (localStorage.getItem('logOutFlag') === "true") {
      this.router.navigate(['/log-out']);
    }
   localStorage.removeItem('searchedEventsCaledarItems');

    this.spinner.show();
    sessionStorage.removeItem("MembershipData");
    this.getDocumentsFolderList(); 

setTimeout(function () {
      this.spinner.hide();
    }.bind(this), 500);

  }

  /** get Folder list
   * @class AdditionalResourceComponent
   * @method getDocumentsFolderList
   */
  public getDocumentsFolderList() {
  this.landingData = {
    "filter": {  },
    "moduleId": 0,
    "page": this.page,
    "presentRole": "",
    "searchTerm": "",
    "size": 50,
    "sortDirection": "ASC",
    "sortProperty": "folder_order",
    "uid": ""
    }
    this.userService.getDiDocumentsFolder(this.landingData).subscribe(data => {
      this.documentsFolderList = data.content;

      this.numberOfElements = data.totalElements;
      this.spinner.hide();
      if (this.documentsFolderList.length === 0) {
    	this.noDataFound = true;
	    this.tableShow = false;
      } else {
	    this.noDataFound = false;
	    this.tableShow = true;
      }
      });
    }

/** to submit resource
   * @class Additional Resource Component
   * @method onManageFolderSubmit
   */
  public onManageFolderSubmit() {
    this.alertSuccess = false;
    this.alertFailure = false;
    this.alertUpdateSuccess = false;
    this.timeOutError = false;
    this.deleteSuccess = false;

    this.method = "addDocumentsFolder";
    this.param = '';
    if(this.editAndSave){
    this.msg1 = " Are you sure you want to update ? ";
  }else{
    this.msg1 = " Are you sure you want to save ? ";
  }

  }


  /** to add new folder
    * @class Additional Resource Component
    * @method addFolder
    */
  public addDocumentsFolder() {
    this.alertSuccess = false;
    this.alertFailure = false;
    this.timeOutError = false;
    this.deleteSuccess = false;
    this.alertUpdateSuccess = false;
    this.modifiedDateTime = new Date();
    let folderData = null;
    this.spinner.show();
    if(this.folderId != null)
    {
      folderData = {
        "folderId" : this.folderId,
        "folderName" : this.folderName,
        "id" : this.userId,
        "folderOrder" : this.folderOrder
    }
    }
    else{
    folderData = {
        "folderId" : 0,
        "folderName" : this.folderName,
        "id" : this.userId,
        "folderOrder" : this.folderOrder
    }
  }
    this.userService.addDiDocumentsFolder(folderData).subscribe(data => {
  if(data.body.message){
	this.spinner.hide();
	this.errorMsg = data.body.message;
	this.alertFailure = true;
	setTimeout(() => {
	  window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
	}, 200);
	return;
      }
 if(this.editAndSave){
	this.alertUpdateSuccess = true;
      }else{
      this.alertSuccess = true;
    }
      this.alertFailure = false;
      this.getDocumentsFolderList();
      this.spinner.hide();
      setTimeout(() => {
	   window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      }, 200);
    }, err => {
      if (err.value.statusText === ConstantValues.unknownError) {
	this.alertFailure = true;
	this.alertSuccess = false;
      }
    })

  }


  /** For filtering data by current page
   * @class Additional Resource Component
   * @method pageChanged
   * @params event
   */
  pageChanged(event) {
    this.page = event - 1;
    this.currentPage = event;

    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElements = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElements = this.numberOfElements;
    }
    this.getDocumentsFolderList();
  }


  public updateDocument(data,i){
    if(this.firstEdit === false){
      this.firstEdit = true;
      this.editFolder(data);
    }else{
    document.getElementById('edit'+i).setAttribute('data-toggle','modal');
    document.getElementById('edit'+i).setAttribute('data-target','#myModal');
    this.method = "editFolder";
    this.param = data;
    this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
    }
  }


  /** to Delete folder
* @class Additional Resource Component
* @method deletefolder
*/
  deleteDiDocumentsFolder(folderId) {
    this.alertSuccess = false;
    this.alertFailure = false;
    this.timeOutError = false;
    this.deleteSuccess = false;
    this.alertUpdateSuccess = false;
    this.spinner.show();
    this.userService.deleteDiDocumentsFolder(folderId).subscribe(_data => {
      this.spinner.hide();
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      this.deleteSuccess = true;
      this.alertSuccess = false;
      this.errorMsgUploadSave = false;
      if (this.documentsFolderList.length === 1 && this.numberOfElements > 10) {
	    this.currentPage = 0;
	    this.page = 0;
    	this.currentShowingElements = 10
}
    this.getDocumentsFolderList();
    });
  }


  /** confirmation to delete folder
* @class Additional Resource Component
* @method deleteFolderConfirmation
*/
  public deleteFolderConfirmation(id) {
    this.alertSuccess = false;
    this.alertFailure = false;
    this.alertUpdateSuccess = false;
    this.timeOutError = false;
    this.deleteSuccess = false;
    this.method = "deleteDiDocumentsFolder";
    this.param = id;
    this.msg1 = "  Deleting folder would delete all the files in it, Are you sure you want to delete ? ";
  }


  public getDocumentsFolderListForSearch() {
    this.page = 0;
    this.currentPage = 1;
    this.getDocumentsFolderList();

  }

  editFolder(data) {
    this.alertSuccess = false;
    this.alertFailure = false;
    this.alertUpdateSuccess = false;
    this.timeOutError = false;
    this.deleteSuccess = false;
    this.editAndSave = true;
    this.folderId = data.folderId;
    this.folderName = data.folderName;
    this.chapterId = data.chapterId;
    this.folderOrder = data.folderOrder;
    this.createdDateTime = data.createdDateTime;
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }


  /** to select cancel
    * @class CreateAndEditExpenseClaimComponent
    * @method cancelClick
    */
  cancelClick() {
    this.method = "navigate";
    this.msg1 = " Are you sure you want to leave this page ? Changes you made may not be saved.";
    this.param = "";
  }

  navigate() {
    this.location.back();
    window.scrollTo(0, 0);
  }
}
